import React, { Component } from 'react';
import { registerPartnerInd, getCatDrop, emailExist } from '../../API/FetchCall';
import FetchCall, { getPlan, CreatePay, getLocation, verifyVendor} from '../../API/FetchCall';
import Recaptcha from 'react-recaptcha';
import { MOBILE_REGEX, URL_REGEX, GOOGLE_CAPTCHA_SITE_KEY } from '../../constant.js';
import SimpleReactValidator from 'simple-react-validator';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { BASEURL } from '../../constant';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();
class InstitutionalSignup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      btnDisable: false,
      signup_form: true,
      ins_first_next: false,
      ind_second_next: false,
      register_step2: false,
      paymentMode: '',
      organisation_name: '',
      user_type: '1',
      user_name: '',
      organisation_register_number: '',
      institution_contact_number: '',
      institution_email_address: '',
      email_id: '',
      phone_number: '',
      organisation_type: '',
      state: '',
      location: '',
      pin_code: '',
      address: '',
      password: '',
      cpassword: '',
      cheque_image: '',
      package_type: '',
      payment_mode: '1',
      errors: [],
      address2: 'Test',
      org_type_list: [],
      social_media_link: '',
      is_org: false,
      is_owner: false,
      incharge_name: '',
      incharge_text: 'In-Charge ',
      social_link: '',
      socialPlace: 'LinkedIn',
      agree: '',
      designation: '',
      cateList: [],
      autoSuggCate: [],
      state_name: '',
      ins_first_name: '',
      ins_last_name: '',
      owner_type: '',
      designation: '',
      email_address: '',
      phone_number: '',
      landline_number: '',
      ins_user_name: '',
      ins_password: '',
      ins_cpassword: '',
      package_list: [],
      plan_id: localStorage.getItem("plan_id") ? localStorage.getItem("plan_id") : '0',
      ind_first_name: '',
      ind_last_name: '',
      ind_location: '',
      ind_state_name: '',
      ind_address: '',
      ind_pin_code: '',
      ind_email_id: '',
      ind_phone_number: '',
      ind_landline_number: '',
      ind_social_link: '',
      ind_social_media_link: '',
      ind_organisation_type: '',
      ind_user_name: '',
      ind_password: '',
      ind_cpassword: '',
      ind_agree: '',
      planinfo_option: true,
      category_List: [],
      categorySubTypeList: [],
      category_id: [],
      sub_category_id: [],
      agree_data: '',
      plan_price: 0,
      isEmailValid: true,
      isUserValid: true,
      id_proof: 0,
      id_proof_no: '',
      qualification: 0,
      othercomments: '',
      isVerified: false,
      id_proof_list: [],
      qualification_list: [],
      location_list: [],
      showPassword: false,
      showCPassword: false,
      showOTPform:false,
      otp:'',
      userid:'',
      otpverified:false,
    }
    this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    this.orgList();
    this.getLocation();
    this.cateList();
    this.idProofList();
    this.qualificationList();
    this.categoryList();
    // $('.selectpicker').selectpicker('refresh');
    this.validator = new SimpleReactValidator({
      validators: {
        password_custome: {  // name the rule
          message: 'The :attribute must be a Min of 8 characters in length - One Capital Letter, One Number, One Character.',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        confirmpassword: {  // name the rule
          message: 'The :attribute must be Same as Password.',
          rule: (val, params, validator) => {
            if (val != this.state.ind_password) {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        emailExist: {  // name the rule
          message: 'The :attribute Already Exist.',
          rule: (val, params, validator) => {
            return this.state.isEmailValid;
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        userExist: {  // name the rule
          message: 'The :attribute Already Exist.',
          rule: (val, params, validator) => {
            return this.state.isUserValid;
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        checkMobile: MOBILE_REGEX,
        checkUrl: URL_REGEX
      }
    });

    this.handleSubmit = this.handleSubmit.bind(this);

  }
  validateMail = (value, type) => {
    let name = (type == 1) ? 'email_id' : 'user_name';
    let type_name = (type == 1) ? 'isEmailValid' : 'isUserValid';
    let req = JSON.stringify({
      [name]: value
    });
    let res = emailExist(req).then(res => {
      if (res.status === 1) {
        this.setState({
          [type_name]: false
        });
      } else {
        // return res.status;
        this.setState({
          [type_name]: true
        });
      }
    });
  }
  async cateList() {
    getCatDrop(0).then((res) => {
      if (res.status === 1) {
        var list = res.results;
        list.map((item, i) => {
          item.options = item.options.flat(Infinity);
        })
        let fiArr = [];
        list.map((item, i) => {
          fiArr.push(item.options);
        })
        fiArr = fiArr.flat(Infinity);
        this.setState({
          cateList: res.results,
          autoSuggCate: fiArr,
        });
      }
    });

  }
  async getLocation() {
    let req = JSON.stringify({
      url: 'getLocation'
    });
    getLocation(req).then(res => {
      if (res.status === 1) {
        this.setState({
          location_list: res.results
        });
      }
    })
  }
  async categoryList() {
    let response = await FetchCall.getSubCategory('0');
    console.log('AgeList', response);
    if (response) {
      this.setState({ category_List: response.results });
    }
  }
  async idProofList() {
    let response = await FetchCall.getSchoolListDatas('id_proof');
    console.log('id_proof_list', response);
    if (response) {
      this.setState({ id_proof_list: response.results });
    }
  }
  async qualificationList() {
    let response = await FetchCall.getSchoolListDatas('qualification');
    console.log('qualification_list', response);
    if (response) {
      this.setState({ qualification_list: response.results });
    }
  }
  getSelect = () => {

    let rows = '';
    {
      rows = this.state.cateList.length > 0 &&
        this.state.cateList.map((item, i) => {
          return (
            <option value={item.category_id} data-tokens={item.options.toString()}>{item.label}</option>
          )
        })
    }

    return rows;

  }
  showValidationErr(elm, msg) {
    this.setState((prevState) => ({ errors: [...prevState.errors, { elm, msg }] }));
  }
  clearValidationErr(elm) {
    this.setState((prevState) => {
      let newArr = [];
      for (let err of this.state.errors) {
        if (elm !== err.elm) {
          newArr.push(err);
        }
      }
      return { errors: newArr };
    })

  }
  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }
  componentDidMount() {
    this.getPlanList();

  }

  async Sub_Cat_type(id) {
    if (id) {
      let response = await FetchCall.getSubCategory(id);
      if (response.status == 1) {
        this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
      } else {
        this.setState({
          categorySubTypeList: []
        })
      }
    } else {
      this.setState({
        categorySubTypeList: []
      })
    }
  }

  getPlanList = async () => {

    let insdata = JSON.stringify({
      user_type: 2,
    })
    try {
      getPlan(insdata).then((response) => {
        let list = response.results;
        let plan_info = list.filter(o => o.id == this.state.plan_id);
        console.log('plan_info', plan_info);
        if (plan_info.length > 0) {
          this.setState({
            package_list: response.results,
            plan_price: plan_info[0]['plan_month_disc'],
            plan_price_original: plan_info[0]['plan_month_original'],
            discount: plan_info[0]['discount'],
            discount_amount: plan_info[0]['discount_amount'],
            plan_info: plan_info[0]['plan_offer'],
            planinfo: plan_info[0]['about_words_count'] + 'Word Write up @ Site about institution' +
              'Upto ' + plan_info[0]['image_count'] + ' Images for Uploads @ profile ' +
              '' + plan_info[0]['plan_access'] + ' access to portal',
          });
        }
        this.setState({
          package_list: response.results,
        });

      });

    } catch (error) {
      this.setState({ error: true });
    }
  }
  handleShowPassword() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }
  handleShowCPassword() {
    this.setState((prevState) => ({
      showCPassword: !prevState.showCPassword,
    }));
  }
  async orgList() {
    let response = await FetchCall.getSubCategory('0');
    console.log('boeList', response);
    if (response) {
      this.setState({ org_type_list: response.results });
    }
  }

  recaptchaLoaded = (e) => {
    console.log('Successfully loaded');
  }
  verifyCallback = (response) => {
    if (response) {
      this.setState({
        isVerified: true,
      });
    }

  }
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });

    if (propName == 'ind_agree') {
      this.setState({
        agree_data: 'checked',

      });
    }
    if (e.target.value !== '') {
      this.clearValidationErr(propName);
    }
    if (propName == 'ind_email_id') {
      this.validateMail(e.target.value, 1);
    }
    if (propName == 'ind_user_name') {
      this.validateMail(e.target.value, 2);
    }
    if (propName === 'user_type' && e.target.value === '1') {
      this.clearValidationErr('organisation_register_number');
    }
    if (propName === 'user_type' && e.target.value === '2') {
      this.setState({
        is_org: true,
        is_owner: false
      });
    } else if (propName === 'user_type' && e.target.value === '1') {
      this.setState({
        is_org: false,
        is_owner: false,
        incharge_text: 'In-Charge',
        designation: '',
        incharge_name: ''
      });
    }

    if (propName === 'plan_id') {

      if (e.target.value == '0') {
        this.setState({
          planinfo_option: false
        });
      } else {
        let plan_id = e.target.value;
        let plan_info = this.state.package_list.filter(o => o.id == plan_id);
        let price = (parseInt(plan_info[0]['plan_month_disc']));
        this.setState({
          planinfo_option: true,
          plan_price: price,
          plan_price_original: plan_info[0]['plan_month_original'],
          discount: plan_info[0]['discount'],
          discount_amount: plan_info[0]['discount_amount'],
          plan_info: plan_info[0]['plan_offer'],
          planinfo: plan_info[0]['about_words_count'] + 'Word Write up @ Site about institution' +
            'Upto ' + plan_info[0]['image_count'] + ' Images for Uploads @ profile ' +
            '' + plan_info[0]['plan_access'] + ' access to portal',
        });
      }

    }

  };

  handleClick = (e) => {
    console.log(e.target.name)
    const propName = e.target.name;
    this.setState(prevState => ({
      [propName]: !prevState[propName]
    }));
    console.log('sad', e.target.value)
    if (propName === 'is_owner' && e.target.value === 'false') {
      this.setState({
        incharge_text: '',
        designation: ''
      })
    } else if (propName === 'is_owner' && e.target.value === 'true') {
      this.setState({
        incharge_text: 'In-Charge ',
      })
    }
  }

  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
    this.clearValidationErr(propName);
    if (propName === 'ind_social_link' && value[0] === 'fb') {
      this.setState({
        socialPlace: 'Facebook'
      })
    } else if (propName === 'ind_social_link' && value[0] === 'twt') {
      this.setState({
        socialPlace: 'Twitter'
      })
    } else if (propName === 'ind_social_link' && value[0] === 'lnkin') {
      this.setState({
        socialPlace: 'LinkedIn'
      })
    } else if (propName === 'ind_social_link' && value[0] === 'insta') {
      this.setState({
        socialPlace: 'Instagram'
      })
    }

    if (propName === 'category_id') {
      let categoryid = e.target.value;
      this.setState({
        sub_category_id: []
      })
      this.Sub_Cat_type(categoryid);
    }
  };

  handleplaceChangeInd = ind_address => {
    this.setState({ ind_address, ind_pin_code: '', ind_state_name: '', ind_location: '' });
    this.clearValidationErr('ind_address');
  };

  handleplaceSelectInd = ind_address => {
    this.setState({ ind_address: ind_address });
    this.clearValidationErr('ind_address');
    // this.Geocode_location();
    Geocode.fromAddress(ind_address).then(
      response => {

        var geolen = response.results[0].address_components.length;
        var pincode = '';
        var state = '';
        var city = '';
        for (let i = 0; i < geolen; i++) {

          if (response.results[0].address_components[i].types[0] == "postal_code") {
            pincode = response.results[0].address_components[i].short_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
            state = response.results[0].address_components[i].long_name;
          }
          if (response.results[0].address_components[i].types[0] == "locality") {
            city = response.results[0].address_components[i].long_name;
          }

        }


        this.get_ind_location(pincode, state, city);
      },
      error => {
        console.error(error);
      }
    );
  };


  Geocode_location() {
    Geocode.fromAddress(this.state.address).then(
      response => {

        var geolen = response.results[0].address_components.length;
        var pincode = '';
        var state = '';
        var city = '';
        for (let i = 0; i < geolen; i++) {

          if (response.results[0].address_components[i].types[0] == "postal_code") {
            pincode = response.results[0].address_components[i].short_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
            state = response.results[0].address_components[i].long_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
            city = response.results[0].address_components[i].long_name;
          }

        }


        this.get_location(pincode, state, city);
      },
      error => {
        console.error(error);
      }
    );

  }


  get_location(pincode, state, city) {
    console.log(pincode, state, city);
    this.setState({
      pin_code: pincode,
      state: state,
      location: city,
    });
  }
  get_ind_location(pincode, state, city) {
    console.log(pincode, state, city);
    this.setState({
      ind_pin_code: pincode,
      ind_state_name: state,
      ind_location: city,
    });
  }
  handlecontactdetails = () => {
    this.setState({ register_step1: false, register_step2: true })
  }

  handlePaymentMode = (e) => {
    this.setState({
      paymentMode: e.target.value
    })
  }
  handlecontactdetails = (e) => {
    this.setState({
      register_step2: true, register_step1: false
    })
  }
  handleFile = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] });
    this.clearValidationErr(e.target.name);
  };

  getRender = (params) => {

    return (<TextField
      {...params}
      variant="outlined"
      placeholder="Type Category Here"
    />);
  }
  onTagsChange = (event, values) => {

    let list = this.state.cateList;
    list.map((item, i) => {
      item.options = item.options.flat(Infinity);
    });
    var finalArr = [];
    list.map((item, i) => {
      let intersection = item.options.filter(x => values.includes(x));
      if (intersection.length > 0) {
        finalArr.push(item.category_id)
      }
    });

    this.setState({
      ind_organisation_type: finalArr,
      sub_category: values,
    })

  }


  isPasswordValid = () => {
    var password = this.state.ind_password;
    var paswd = /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
    if (password.match(paswd)) {
      return true;
    } else {
      this.showValidationErr("ind_password", "Min of 8 characters in length – One Capital Letter, One Number, One Character")
      return false;
    }
  }

  isEmailValid = () => {
    var email = this.state.ind_email_id;
    const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (reg.test(email) !== true) {
      this.showValidationErr("ind_email_id", "Please Enter Valid Email id");
      return false;
    } else {
      return true;
    }

  }


  handleVerifyUser = (e) => {

    let ins = '';

    ins = JSON.stringify({
      user_id: this.state.userid,
      otp:this.state.otp
    });

    verifyVendor(ins).then((res) => {

      if (res.status === 1) {
         
        this.setState({otpverified:true})

      }


    });

}

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      let ins = '';
      this.setState({
        btnDisable: true
      });
      ins = JSON.stringify({
        user_type: 2,
        social_link: this.state.social_link,
        social_media_link: this.state.ind_social_media_link,
        sub_category: this.state.sub_category_id,
        user_paytype: 2,
        first_name: this.state.ind_first_name,
        last_name: this.state.ind_last_name,
        address: this.state.ind_address,
        pin_code: this.state.ind_pin_code,
        state: this.state.ind_state_name,
        location: this.state.ind_location,
        email_id: this.state.ind_email_id,
        phone_number: this.state.ind_phone_number,
        landline_number: this.state.ind_landline_number,
        category_id: this.state.category_id,
        user_name: this.state.ind_user_name,
        password: this.state.ind_password,
        cpassword: this.state.ind_cpassword,
        agree: this.state.ind_agree,
        id_proof: this.state.id_proof,
        id_proof_no: this.state.id_proof_no,
        qualification: this.state.qualification,
        othercomments: this.state.othercomments,
        main_category_id: this.state.category_id,
      });

      let toastr = '';
      if (!this.state.isVerified) {

        alert("Please verify the checkbox!");
        
        return false;
      }
      registerPartnerInd(ins).then((res) => {
        
        if (res.status === 1) {

          this.setState({
            signup_form:false,
            showOTPform: true,
            userid:res.userid
          });
          /*
          alert("Thanks for partnering with BeWise.Your request has been submitted. A confirmation mail has been sent your mail");
          setTimeout(function () {
            window.location.replace('/login');
          }, 2000);
           */

        } else {
          this.setState({
            btnDisable: false
          });
          let er = res.errors[0].msg
          alert(window.toastr.error);
          
        }
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }


  render() {
    this.validator.purgeFields();
    console.log('ind_location', this.state.ind_location)
    return (
      <div className="container-fluid">
        <form>
          <div className="row">
            <div className="col-md-6 col-sm-6 sign-bg-login   hidden-xs">
              <div className="shadow-bg"></div>
              <h1>
                Welcome to
                <br /> BeWise Partner Program
              </h1>
            </div>
            <div className="col-md-6 col-sm-6 signup-right">
              <div className="inner-right">
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="right-logo">
                      <a href='/individual'>
                        <img src="assets/images/bewiselogo.png" />
                      </a>
                    </div>

                    {(this.state.signup_form === false && this.state.showOTPform===true) ?
                      <div>
                        <h1>Verification</h1>


                        {this.state.otpverified && 

                      <div class="aftervrying alert alert-success">
                          
                            Thank you for registering with us and your account has been verified successfully. Please click <a href="/login">here</a> to login and become bewise partner

                      </div>
                      }

                      {!this.state.otpverified &&
                        <div>
                        <div class="smalltext">We have sent you an OTP to your registering email id successfully</div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                               <label>OTP<span className="astrick">(you may have received in your inbox or junk or spam)</span></label>

                               <div className="custom-select-drop dropdown">
                                <input type="text" name="otp"
                                  value={this.state.otp}
                                  placeholder="OTP"
                                  onChange={this.handleChange}
                                  className="form-control"  />
                                {this.validator.message('Verification OTP', this.state.otp, 'required', { className: 'text-danger' })}
                              </div>

                            </div>
                          </div>

                          <div className="col-md-12 col-sm-12 text-right">
                            <button type='button' className="btn orange-btn" onClick={this.handleVerifyUser}>Verify</button>
                          </div>
                         
                        </div>
                        </div>
                        }

                      </div>

                      : ''}

                    {(this.state.signup_form === true && this.state.showOTPform===false) ?                        
                    <div>
                      <form onSubmit={this.handleSubmit}>
                        <h1>Individual Details</h1>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Name <i class="fa fa-info-circle" data-toggle="tooltip" title='Pease make sure only alphabets(no space)' aria-hidden="true"></i> <span class="astrick">*</span></label>
                              <input
                                type="text"
                                placeholder="Name"
                                className="form-control"
                                name="ind_first_name"
                                onChange={this.handleChange}
                                value={this.state.ind_first_name}
                              />
                              {this.validator.message('Name', this.state.ind_first_name, 'required', { className: 'text-danger' })}
                            </div>
                          </div>
                          {/* <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Last Name <i class="fa fa-info-circle" data-toggle="tooltip" title='Pease make sure only alphabets(no space)' aria-hidden="true"></i> <span class="astrick">*</span></label>
                              <input type="text"
                                placeholder="Last Name"
                                className="form-control"
                                name="ind_last_name"
                                onChange={this.handleChange}
                                value={this.state.ind_last_name}
                              />
                              {this.validator.message('Last Name', this.state.ind_last_name, 'required|alpha', { className: 'text-danger' })}
                            </div>
                          </div> */}
                        </div>
                        <div className="row">
                          <div className="col-md-12 col-md-12">
                            <div className="form-group">
                              <label>Address<span class="astrick">*</span></label>
                              <PlacesAutocomplete
                                value={this.state.ind_address}
                                className="form-control"
                                onChange={this.handleplaceChangeInd}
                                onSelect={this.handleplaceSelectInd}
                              >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                  <div >
                                    <input
                                      {...getInputProps({
                                        placeholder: 'Search Places ...',
                                        className: 'form-control',

                                      })}
                                      value={this.state.ind_address}
                                    />
                                    <div className="autocomplete-dropdown-container"
                                      style={{ position: "absolute", zIndex: "999" }}>
                                      {loading && <div>Loading...</div>}
                                      {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                          ? 'suggestion-item--active'
                                          : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                          ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                          : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                        return (
                                          <div
                                            {...getSuggestionItemProps(suggestion, {
                                              className,
                                              style,
                                            })}
                                          >
                                            <span>{suggestion.description}</span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </PlacesAutocomplete>
                              {this.validator.message('Address', this.state.ind_address, 'required', { className: 'text-danger' })}

                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>City<span class="astrick">*</span></label>
                              <div className="custom-select-drop dropdown">
                                {/* <input type="text" name="ind_location"
                                  value={this.state.ind_location}
                                  placeholder="City"
                                  onChange={this.handleChange}
                                  className="form-control" /> */}
                                <select
                                  onChange={this.handleChange}
                                  name="ind_location"
                                  value={this.state.ind_location}
                                  className='form-control selectpicker' title='Select City'>
                                  {this.state.location_list.map((item, i) => {
                                    return (
                                      <option >
                                        {item.location}
                                      </option>
                                    )
                                  })}
                                </select>
                                {this.validator.message('City', this.state.ind_location, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>State<span class="astrick">*</span></label>
                              <div className="custom-select-drop dropdown">
                                <input type="text" name="ind_state_name"
                                  value={this.state.ind_state_name}
                                  placeholder="State"
                                  onChange={this.handleChange}
                                  className="form-control" />
                                {this.validator.message('State', this.state.ind_state_name, 'required|alpha_space', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Pincode<span class="astrick">*</span></label>
                              <input type="number" name="ind_pin_code"
                                className="form-control"
                                placeholder="Pincode"
                                value={this.state.ind_pin_code}
                                onChange={this.handleChange}
                              />
                              {this.validator.message('Pincode', this.state.ind_pin_code, 'required|numeric|min:1,num', { className: 'text-danger' })}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Email Address<span class="astrick">*</span></label>
                              <input type="email" name="ind_email_id"
                                value={this.state.ind_email_id}
                                placeholder="Email Address"
                                onChange={this.handleChange} className="form-control" />
                              {this.validator.message('Email Address', this.state.ind_email_id, 'required|emailExist|email', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12">
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Mobile Number<span class="astrick">*</span></label>
                              {/* <div className="phone-wrapper"> */}
                              {/* <div className="custom-select-drop dropdown">
                                  <select className="form-control selectpicker">
                                    <option>+91</option>
                                  </select>
                                </div> */}
                              <input type="number" name="ind_phone_number"
                                placeholder="Mobile Number"
                                value={this.state.ind_phone_number}
                                onChange={this.handleChange} className="form-control" />

                              {/* </div> */}
                              {this.validator.message('Mobile Number', this.state.ind_phone_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })}
                            </div>

                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Landline Number</label>
                              {/* <div className="phone-wrapper">
                                <div className="custom-select-drop dropdown">
                                  <select className="form-control selectpicker">
                                    <option>+91</option>
                                  </select>
                                </div> */}
                              <input type="number" name="ind_landline_number"
                                placeholder="Landline Number"
                                value={this.state.ind_landline_number}
                                onChange={this.handleChange} className="form-control" />

                              {/* </div> */}
                              {this.validator.message('Landline Number', this.state.ind_landline_number, 'numeric', { className: 'text-danger' })}
                            </div>

                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Identity Proof <i class="fa fa-info-circle" data-toggle="tooltip" title='Copy to be uploaded only upon confirmation as partner @BeWise' aria-hidden="true"></i> <span class="astrick">*</span></label>
                              <select
                                className='form-control selectpicker'
                                title='Select ID' name='id_proof'
                                value={this.state.id_proof}
                                onChange={this.handleSelect}>
                                {this.state.id_proof_list && this.state.id_proof_list.map((item, i) => {
                                  return (
                                    <option value={item.id} >
                                      {item.name}
                                    </option>
                                  )
                                })}
                              </select>
                              {this.validator.message('Select ID proof', this.state.id_proof, 'required', { className: 'text-danger' })}
                            </div>
                          </div>
                          {this.state.id_proof != 0 && (
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label>ID proof number<span class="astrick">*</span></label>
                                <input type="text" name="id_proof_no"
                                  placeholder="ID proof Number"
                                  value={this.state.id_proof_no}
                                  onChange={this.handleChange} className="form-control" />
                                {this.validator.message('ID proof Number', this.state.id_proof_no, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          )}

                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Social media links<span class="astrick">*</span></label>
                              <select className="form-control"
                                title="Select"
                                name="ind_social_link"
                                onChange={this.handleSelect}
                                value={this.state.ind_social_link.toString()}>
                                <option value=''>Select</option>
                                <option value='lnkin'>LinkedIn </option>
                                <option value='fb'>Facebook </option>
                                <option value='insta'>Instagram </option>
                                <option value='twt'>Twitter </option>
                              </select>
                              {this.validator.message('Landline Number', this.state.ind_social_link, 'required', { className: 'text-danger' })}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Social media link or page name  <i class="fa fa-info-circle" data-toggle="tooltip" title='Please copy paste url from your social media home page' aria-hidden="true"></i> <span class="astrick">*</span></label>
                              <input id="social_media_link" type="text" name="ind_social_media_link"
                                value={this.state.ind_social_media_link}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder={this.state.socialPlace} />
                              {this.validator.message('Social media link', this.state.ind_social_media_link, 'required', { className: 'text-danger' })}
                              {this.validator.message('Social media link must start with `https://...` and it', this.state.ind_social_media_link, 'url', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div> */}
                        <div className="row">

                          <div className="col-lg-6 col-md-12">
                            <div className="form-group  min-h-unset">
                              <label>Category<span class="astrick">*</span></label>
                              <select
                                onChange={this.handleSelect}
                                name="category_id"
                                value={this.state.category_id.toString()}
                                className='form-control' title='Select Category'>
                                <option value=''>Select</option>
                                {this.state.category_List.length > 0 &&
                                  this.state.category_List.map((item, i) => {
                                    if (item.category_id > 3) {
                                      return (
                                        <option value={item.category_id} >
                                          {item.category_name}
                                        </option>
                                      )
                                    }
                                  })}
                              </select>
                              {this.validator.message('Category', this.state.category_id, 'required', { className: 'text-danger' })}
                            </div>

                          </div>
                          {!this.state.category_id.includes('4') && (
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label>Sub Category<span class="astrick">*</span></label>
                                <select
                                  onChange={this.handleSelect}
                                  name="sub_category_id"
                                  value={this.state.sub_category_id}
                                  className='form-control selectpicker'
                                  multiple title='Select' >
                                  {this.state.categorySubTypeList.length > 0 &&
                                    this.state.categorySubTypeList.map((item, i) => {
                                      return (
                                        <option value={item.category_id} key={i}>
                                          {item.category_name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Sub Category', this.state.sub_category_id, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          )}
                          {this.state.category_id.includes('4') && (
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <label>Sub Category<span class="astrick">*</span></label>
                                <select
                                  onChange={this.handleSelect}
                                  name="sub_category_id"
                                  value={this.state.sub_category_id.toString()}
                                  className='form-control'
                                  title='Select' >
                                  <option value=''>Select</option>
                                  {this.state.categorySubTypeList.length > 0 &&
                                    this.state.categorySubTypeList.map((item, i) => {
                                      return (
                                        <option value={item.category_id} key={i}>
                                          {item.category_name}
                                        </option>
                                      )
                                    })}
                                </select>
                                {this.validator.message('Sub Category', this.state.sub_category_id, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          )}



                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Highest Qualification <i class="fa fa-info-circle" data-toggle="tooltip" title='Certificate upload required only upon confirmation as partner @BeWise' aria-hidden="true"></i> <span class="astrick">*</span></label>
                              <select
                                className='form-control selectpicker'
                                title='Select qualification' name='qualification'
                                value={this.state.qualification}
                                onChange={this.handleSelect}>
                                {this.state.qualification_list && this.state.qualification_list.map((item, i) => {
                                  return (
                                    <option value={item.id} >
                                      {item.name}
                                    </option>
                                  )
                                })}
                              </select>
                              {this.validator.message('Select Qualification', this.state.qualification, 'required', { className: 'text-danger' })}
                            </div>
                          </div>

                        </div>
                        <div className="row">
                          <div className="col-lg-12 col-md-12">
                            <div className="form-group">
                              <label>Other Comments/Information</label>
                              <textarea type="text" name="othercomments" value={this.state.othercomments}
                                onChange={this.handleChange} className="form-control"></textarea>
                              {this.validator.message('Other Comments/Information', this.state.othercomments, '', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="row mar-top">
                          <div className="col-md-12 col-sm-12">
                            <h1>Login Details</h1>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>User Name<span class="astrick">*</span></label>
                              <input type="text" name="ind_user_name" value={this.state.ind_user_name}
                                placeholder="User Name"
                                onChange={this.handleChange} className="form-control" />
                              {this.validator.message('User Name', this.state.ind_user_name, 'required|alpha_num|userExist', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12">
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Password<span class="astrick">*</span></label>
                              <input id="password-field" type={this.state.showPassword ? 'text' : 'password'} name="ind_password"
                                placeholder="Password"
                                value={this.state.ind_password}
                                onChange={this.handleChange}
                                className="form-control" />
                              <span
                                toggle='#password-field'
                                className={this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon'}
                                onClick={() => {
                                  this.handleShowPassword();
                                }}
                              ></span>
                              {this.validator.message('Password', this.state.ind_password, 'required|password_custome', { className: 'text-danger' })}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Confirm Password<span class="astrick">*</span></label>
                              <input id="password-fieldc" type={this.state.showCPassword ? 'text' : 'password'} name="ind_cpassword"
                                placeholder="Confirm Password"
                                value={this.state.ind_cpassword}
                                onChange={this.handleChange}
                                className="form-control" />
                              <span
                                toggle='#password-field'
                                className={this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon'}
                                onClick={() => {
                                  this.handleShowCPassword();
                                }}
                              ></span>
                              {this.validator.message('Confirm Password', this.state.ind_cpassword, 'required|confirmpassword', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <Recaptcha
                                sitekey={GOOGLE_CAPTCHA_SITE_KEY}
                                render="explicit"
                                onloadCallback={this.recaptchaLoaded}
                                verifyCallback={this.verifyCallback}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12 pad-hor-no">
                          <label className="custom-checkboxs" style={{ marginTop: "10px" }}>
                            <label>
                              <input type="checkbox" className=""
                                name="ind_agree"
                                value="Yes"
                                onChange={this.handleChange}
                                checked={this.state.agree_data} />
                              &nbsp;&nbsp; I Agree to <span style={{ color: "#1492E6" }}>
                                <a href="javascript:window.open('/termsconditions', 'termsconditions', 'width=auto,height=auto')">
                                  Terms of service
                                </a> and &nbsp;
                                <a href="javascript:window.open('/privacypolicy', 'privacypolicy', 'width=auto,height=auto')" target="_blank">
                                  Privacy policy
                                </a>
                                <span class="astrick">*</span></span></label>
                          </label>
                          <br />
                          {this.validator.message('Agree', this.state.agree_data, 'required', { className: 'text-danger' })}
                        </div>
                        <div className="col-md-12 col-sm-12 text-right pad-hor-no">
                          <button type='submit' className="btn orange-btn" disabled={this.state.btnDisable}
                          >{this.state.btnDisable ? 'Please Wait...' : 'Submit'}
                          </button>
                          <br />
                        </div>
                        <div>
                          <p>
                            <span className='text-left'>
                              Our business development team will get in touch with you soon.
                              On successful verification You will be able to login
                            </span>
                          </p>
                        </div>
                      </form>
                    </div> : ''}
                   
                  </div>
                </div>


              </div>
            </div>
          </div>
        </form>
      </div >
    )
  }
}

export default InstitutionalSignup;


// WEBPACK FOOTER //
// ./src/components/SignUp/individual_signup.jsx